import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setWithdrawalScaleTypeOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'

export function* getWithdrawalScaleTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const withdrawScaleTypeResponse: IOptionsResponse = yield call([
      vitalsService,
      vitalsService.getWithdrawalScaleType,
    ])

    if (!withdrawScaleTypeResponse?.entity) {
      return
    }

    yield put(setWithdrawalScaleTypeOptions(withdrawScaleTypeResponse.entity))
  } catch (e) {
    yield put(throwPcrException(`getWithdrawalScaleTypeOptions() error: ${e}`))
  }
}

export function* getWithdrawalScaleTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getWithdrawalScaleTypeOptions)
}
